import './CreateProductLandingPage.css';
import CreateProductLandingPage from './CreateProductLandingPage';

export default CreateProductLandingPage;



// WEBPACK FOOTER //
// ./src/components/CreateProductLandingPage/index.ts